import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { SignupScreen } from '@/screens/accounts/SCR-102-signup'

// SCR-102 Create an account (accounts area).
export const Route = createFileRoute('/_public/signup')({
  validateSearch: z.object({
    next: z.string().max(2000).optional().catch(undefined),
    email: z.string().max(200).optional().catch(undefined),
    invite: z.string().max(200).optional().catch(undefined),
  }),
  component: function Signup() {
    return <SignupScreen search={Route.useSearch()} />
  },
})
